export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'

export interface ShowNotification {
  type: typeof SHOW_NOTIFICATION
  payload: string
}

export interface HideNotification {
  type: typeof HIDE_NOTIFICATION
  payload: null
}

export interface NotificationState {
  openNotification: string | null
}

export const InitialState: NotificationState = {
  openNotification: null
}

export type NotificationActions = ShowNotification | HideNotification